import { ErrorHandler as AngularErrorHandler, Injectable } from '@angular/core'
import * as Sentry from '@sentry/angular'
import { DevLog } from 'depoto-core/src/entities'
import { Events } from 'depoto-core/src/utils'

@Injectable()
export class ErrorHandler extends AngularErrorHandler {
  private readonly sentryErrorHandler = Sentry.createErrorHandler({ logErrors: false })

  public handleError(e: unknown): void {
    this.sentryErrorHandler.handleError(e)
    const error = e as
      | {
          message?: unknown
          url?: unknown
          lineNo?: unknown
          columnNo?: unknown
          stack?: unknown
        }
      | null
      | undefined
    const log = new DevLog({
      name: DevLog.names.error,
      content: JSON.stringify({
        msg: error?.message,
        url: typeof error?.url === 'string' ? error.url : window.location.href,
        lineNo: error?.lineNo,
        columnNo: error?.columnNo,
        stack: error?.stack,
      }),
    })
    Events.dispatch('logger-error', log)
    super.handleError(e)
  }
}
